import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import UserContext from '../../product/context/user/userContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import { Button } from '@mui/material'
import { LinearProgress } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Country as CSCCountry, State as CSCState } from 'country-state-city'
import moment from 'moment'
import AuthContext from '@/product/context/auth/authContext'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import { dateFormatFrontOnlyDate } from '../../custom/common/components'
import './UserManage.css'
import Loaders from '../../product/components/molecules/Loaders'

const UserManage = (props) => {
    const userContext = useContext(UserContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext

    const [isLoading, setIsLoading] = useState(false)
    const data = props.data
    const toggleFullScreenPopup = props.function

    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    const validationArray = Yup.object({
        first_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        last_name: Yup.string()
            .min(2, 'Minimum 2 characters')
            .max(250, 'Maximum 250 characters')
            .required('Required!'),
        address1: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character')
            .required('Required!'),
        address2: Yup.string()
            .trim()
            .matches(
                /^[0-9a-zA-Z- ,.#()]*$/g,
                'Some kind of special characters not allowed'
            )
            .max(250, 'Maximum 250 Character'),
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        confirm_email: Yup.string()
            .email('Invalid email format')
            .test('equal', 'emails_do_not_match', (item) =>
                item
                    ? item.toLowerCase() === formik.values.email.toLowerCase()
                    : true
            )
            .required('Required'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        country: Yup.string().trim().required('Required!'),
        city: Yup.string().required('Required!'),
        state: Yup.string().trim().required('Required!'),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'The positive numeber only')
            .max(6, 'maximum 6 characters')
            .min(3, 'minimum 3 characters')
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            confirm_email: '',
            first_name: '',
            last_name: '',
            address1: '',
            address2: '',
            phone: '',
            city: '',
            country: global.defaultCountry,
            state: '',
            zip: '',
            companyname: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            const value = values
            userAction(value)
        },
    })
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (single_user.record && data.status === 'edit') {
            const userEdit = single_user.record
            formik.setValues({
                // Here We Iniatalize the fields to show orignal data
                id: userEdit.id,
                first_name: userEdit.first_name,
                last_name: userEdit.last_name,
                // passport_number: userEdit.passport_number,
                // emirates_id: userEdit.emirates_id ? userEdit.emirates_id : '',
                companyname: userEdit.companyname,
                phone: userEdit.phone,
                email: userEdit.email,
                confirm_email: userEdit.email,
                state: userEdit.state,
                city: userEdit.city,
                address1: userEdit.address1,
                address2: userEdit.address2,
                zip: userEdit.zip,
                country: userEdit.country,
            })
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_user])

    useEffect(() => {
        const userAdd = single_user?.record
        if (
            userAdd &&
            userAdd.country &&
            formik.values.country === userAdd.country
        ) {
            formik.setFieldValue('state', userAdd.state)
        } else {
            formik.setFieldValue('state', '')
        }
    }, [formik.values.country])

    const resetFrom = () => {
        formik.values.email = ''
        formik.values.address1 = ''
        formik.values.address2 = ''
        formik.values.city = ''
        formik.values.first_name = ''
        formik.values.last_name = ''
        formik.values.phone = ''
        formik.values.state = ''
        formik.values.zip = ''
        formik.values.country = global.defaultCountry
        formik.handleReset()
        setIsLoading(false)
    }

    const IndividualRegistration = {
        formik: formik,
        data: [
            {
                label: t('first_name') + '*',
                name: 'first_name',
                type: 'text',
                placeholder: t('enter_your_first_name'),
                class: 'col-12 col-sm-6',
                autoFocus: true,
            },
            {
                label: t('last_name') + '*',
                name: 'last_name',
                type: 'text',
                placeholder: t('enter_your_last_name'),
                class: 'col-12 col-sm-6',
            },
            {
                label: 'Company ' + '*',
                name: 'companyname',
                type: 'text',
                placeholder: 'Enter your company name',
                class: 'col-12 col-sm-6',
            },
        ],
    }

    if (data.status === 'new') {
        IndividualRegistration.data.push(
            {
                label: t('email_address') + '*',
                name: 'email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
            },
            {
                label: t('confirm_email_address') + '*',
                name: 'confirm_email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
            }
        )
    } else {
        IndividualRegistration.data.push(
            {
                label: t('email_address') + '*',
                name: 'email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
            },
            {
                label: t('confirm_email_address') + '*',
                name: 'confirm_email',
                type: 'email',
                placeholder: t('enter_your_email_address'),
                class: 'col-12 col-sm-6',
            }
        )
    }
    IndividualRegistration.data.push(
        {
            label: t('mobile_number') + '*',
            name: 'phone',
            type: 'phone',
            placeholder: t('mobile_number'),
            class: 'col-12 col-sm-6',
        },
        // {
        //     label: t('emirates_id') + '*',
        //     name: 'emirates_id',
        //     type: 'text',
        //     placeholder: t('enter_your_emirates_id'),
        //     class: 'col-12 col-sm-6',
        // },
        // {
        //     label: t('passport_number') + '*',
        //     name: 'passport_number',
        //     type: 'text',
        //     placeholder: t('enter_your_passport_number'),
        //     class: 'col-12 col-sm-6',
        // },
        {
            label: t('country') + '*',
            placeholder: t('select_your_country'),
            class: 'col-12 col-sm-6',
            type: 'select',
            options: CSCCountry.getAllCountries()
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
        },
        {
            label: t('state') + '*',
            placeholder: t('select_your_state'),
            class: 'col-12 col-sm-6',
            type: 'select',
            options: CSCState.getStatesOfCountry(
                formik.values.country
                    ? formik.values.country
                    : global.defaultCountry
            )
                .filter(
                    (state) => global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
        },
        {
            label: t('city') + '*',
            name: 'city',
            type: 'text',
            placeholder: t('enter_your_city'),
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Address Line 1' + '*',
            name: 'address1',
            type: 'text',
            placeholder: t('enter_your_address'),
            class: 'col-12 col-sm-6',
        },
        {
            label: 'Address Line 2' + '*',
            name: 'address2',
            type: 'text',
            placeholder: t('enter_your_address'),
            class: 'col-12 col-sm-6',
        },
        {
            label: t('po_box') + '*',
            placeholder: t('enter_your_post_box_number'),
            class: 'col-12 col-sm-3',
            type: 'number',
            name: 'zip',
        }
    )

    const formSubmit = (e) => {
        formik.handleSubmit(e)
        console.log(formik.errors)
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'userAction') {
                formik.setSubmitting(false)
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])

    const validationPassword = Yup.object({
        change_password: Yup.boolean(),
        new_password: Yup.string()
            .notOneOf(
                [Yup.ref('current_password')],
                'New password must be different'
            )
            .matches(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                'Password must contain at least one lowercase letter, uppercase letter, number and special character'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password')], 'Passwords Not Match')
            .required('Required'),
    })

    const formikPassword = useFormik({
        initialValues: {
            noCurrentCheck: true,
            change_password: 1,
            current_password: '',
            new_password: '',
            confirm_password: '',
        },
        validationSchema: validationPassword,
        onSubmit: (values) => {
            userAction(values)
            setIsLoading(true)
        },
    })

    let [currentPasswordShown, setCurrentPasswordShown] = useState(false)
    let [newPasswordShown, setNewPasswordShown] = useState(false)
    let [confirmPasswordShown, setConfirmPasswordShown] = useState(false)

    const togglePasswordVisiblity = (type) => {
        if (type === 'current') {
            setCurrentPasswordShown(currentPasswordShown ? false : true)
        } else if (type === 'new') {
            setNewPasswordShown(newPasswordShown ? false : true)
        } else if (type === 'confirm') {
            setConfirmPasswordShown(confirmPasswordShown ? false : true)
        }
    }

    const passwordChange = [
        {
            label: 'Password',
            name: 'new_password',
            placeholder: 'Enter your New password',
            class: 'col-md-6 col-sm-12',
            type: newPasswordShown ? 'text' : 'password',
            endAdornment: newPasswordShown ? (
                <span
                    className="material-icons cursorPointer"
                    onClick={() => togglePasswordVisiblity('new')}
                >
                    visibility_off
                </span>
            ) : (
                <span
                    className="material-icons cursorPointer"
                    onClick={() => togglePasswordVisiblity('new')}
                >
                    visibility
                </span>
            ),
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            placeholder: 'Re enter your password',
            class: 'col-md-6 col-sm-12',
            type: confirmPasswordShown ? 'text' : 'password',
            endAdornment: confirmPasswordShown ? (
                <span
                    className="material-icons cursorPointer"
                    onClick={() => togglePasswordVisiblity('confirm')}
                >
                    visibility_off
                </span>
            ) : (
                <span
                    className="material-icons cursorPointer"
                    onClick={() => togglePasswordVisiblity('confirm')}
                >
                    visibility
                </span>
            ),
        },
    ]

    useEffect(() => {
        if (data.status === 'edit') {
            setIsLoading(true)
            formik.values.id = data.id
            formikPassword.values.id = data.id
            getSingleUser(formik.values)
        } else {
            resetFrom()
        }
    }, [data])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW USER'
                    : `EDIT USER: ${single_user.record.first_name || ''} ${
                          single_user.record.last_name || ''
                      }`
            }
            open={
                data.status === 'new' || data.status === 'edit'
                    ? data.popup
                    : false
            }
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <form onSubmit={formSubmit} autoComplete="nofill">
                                <div>
                                    <div className="row">
                                        {mapData(IndividualRegistration)}
                                    </div>
                                </div>

                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        label="Cancel"
                                        onClick={() =>
                                            toggleFullScreenPopup(false)
                                        }
                                    />
                                    <PrimaryButton
                                        type="submit"
                                        label={
                                            data.status === 'new'
                                                ? 'Submit'
                                                : 'Update'
                                        }
                                    />
                                </div>
                            </form>

                            {user?.emp_type === 'super_admin' &&
                            data.status === 'edit' &&
                            data.id ? (
                                <>
                                    <form
                                        onSubmit={formikPassword.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <h2 className="dashTitle">
                                            CHANGE PASSWORD
                                        </h2>
                                        <div className="row">
                                            {mapData({
                                                formik: formikPassword,
                                                data: passwordChange,
                                            })}
                                        </div>
                                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                            <PrimaryButton
                                                id="employee_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </div>
                                    </form>
                                </>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default UserManage
